module.exports = __webpack_public_path__ + "eb64114a3796bbfd98413d723c3f56f4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/backpack.png
// module id = 1226
// module chunks = 0